import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';

import Inicio from './pages/Inicio/Inicio';
import Formaciones from './pages/Formaciones/Formaciones';
import Recursos from './pages/Recursos/Recursos';
import Comunidad from './pages/Comunidad/Comunidad';

import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import AdminLogin from './pages/Admin/Login/AdminLogin';
import AdminLayout from './pages/Admin/Layout/AdminLayout';
import Dashboard from './pages/Admin/Dashboard/Dashboard';
import AdminPlaceholder from './pages/Admin/AdminPlaceholder';
import AdminFormaciones from './pages/Admin/FormacionesGratis/AdminFormaciones';
import AdminRecursos from './pages/Admin/Recursos/AdminRecursos';
import CursoDetalle from './pages/CursoDetalle/CursoDetalle';
import LandingRecurso from './pages/LandingRecurso/LandingRecurso';
import AdminLeads from './pages/Admin/Leads/AdminLeads';
import AdminRecursosGratis from './pages/Admin/RecursosGratis/AdminRecursosGratis';
import AdminSuscriptores from './pages/Admin/Suscriptores/AdminSuscriptores';

import { AuthUserProvider } from './context/AuthUserContext';
import Login     from './pages/Auth/Login';
import Registro  from './pages/Auth/Registro';
import MiCuenta  from './pages/MiCuenta/MiCuenta';
import VerificarEmail from './pages/Auth/VerificarEmail';
import AdminUsuarios from './pages/Admin/Usuarios/AdminUsuarios';
import FormacionGratisDetalle from './pages/FormacionGratisDetalle/FormacionGratisDetalle';
import AdminFormacionesGratis from './pages/Admin/FormacionesGratis/AdminFormacionesGratis';
import AdminPedidos from './pages/Admin/Recursos/AdminPedidos';
import PagoPublico from './pages/PagoPublico/PagoPublico';
import AdminPuntos from './pages/Admin/Puntos/AdminPuntos';
import PagoExitoso from './pages/PagoExitoso/PagoExitoso';
import LibroReclamaciones from './pages/LibroReclamaciones/LibroReclamaciones';
import AdminReclamaciones from './pages/Admin/Reclamaciones/AdminReclamaciones';
import AtencionCliente from './pages/AtencionCliente/AtencionCliente';
import Legal from './pages/Legal/Legal';
import PoliticaDevoluciones from './pages/PoliticaDevoluciones/PoliticaDevoluciones';
import { CartProvider } from './context/CartContext';
import Carrito from './pages/Carrito/Carrito';
import AdminHeroCarrusel from './pages/Admin/HeroCarrusel/AdminHeroCarrusel';
import AdminReportes from './pages/Admin/Reportes/AdminReportes';
import AdminCupones from './pages/Admin/Cupones/AdminCupones';
import RegistroCurso from './pages/RegistroCurso/RegistroCurso';
import RecursoDetalle from './pages/Recursos/RecursoDetalle';

import RecuperarPassword from './pages/Auth/RecuperarPassword';
import ResetPassword from './pages/Auth/ResetPassword';


import Articulos       from './pages/Articulos/Articulos';
import ArticuloDetalle from './pages/ArticuloDetalle/ArticuloDetalle';
import AdminArticulos  from './pages/Admin/Articulos/AdminArticulos';
import AdminComentariosArticulos from './pages/Admin/Articulos/AdminComentariosArticulos';

function App() {
  return (
    
    <CartProvider>

    <Router basename="/">
      <AuthProvider>
        <AuthUserProvider>
          <Routes>

            {/* ── Públicas ── */}
            <Route path="/"               element={<Inicio />} />
            <Route path="/formaciones"    element={<Formaciones />} />
            <Route path="/recursos"       element={<Recursos />} />
            <Route path="/comunidad"      element={<Comunidad />} />
            <Route path="/formaciones/:id" element={<CursoDetalle />} />
            <Route path="/gratis/:slug"   element={<LandingRecurso />} />
            <Route path="/login"          element={<Login />} />
            <Route path="/registro"       element={<Registro />} />
            <Route path="/verificar-email" element={<VerificarEmail />} />
            <Route path="/formaciones-gratis/:slug" element={<FormacionGratisDetalle/>} />
            <Route path="/pago/:token" element={<PagoPublico/>} />
            <Route path="/pago-exitoso" element={<PagoExitoso />} />
            <Route path="/libro-reclamaciones" element={<LibroReclamaciones/>}/>
            <Route path="/atencion-cliente" element={<AtencionCliente/>}/>
<Route path="/legal" element={<Legal/>}/>
<Route path="/politica-devoluciones" element={<PoliticaDevoluciones/>}/>
<Route path="/carrito" element={<Carrito/>}/>
<Route path="/registro-curso" element={<RegistroCurso/>}/>
<Route path="/recursos/:id"        element={<RecursoDetalle/>}/>
<Route path="/articulos"       element={<Articulos/>}/>
<Route path="/articulos/:slug" element={<ArticuloDetalle/>}/>

<Route path="/recuperar-password"  element={<RecuperarPassword/>}/>
            <Route path="/reset-password"      element={<ResetPassword/>}/>

            {/* ── Mi cuenta (protegida usuario) ── */}
            <Route path="/mi-cuenta" element={
              <ProtectedRoute tipo="usuario"><MiCuenta /></ProtectedRoute>
            } />

            {/* ── Admin login ── */}
            <Route path="/admin/login" element={<AdminLogin />} />

            {/* ── Admin protegido ── */}
            <Route path="/admin" element={
              <ProtectedRoute tipo="admin"><AdminLayout /></ProtectedRoute>
            }>
              <Route index element={<Navigate to="dashboard" replace />} />
              <Route path="dashboard"     element={<Dashboard />} />
              <Route path="formaciones"   element={<AdminFormaciones />} />
              <Route path="recursos"      element={<AdminRecursos />} />
              <Route path="leads"         element={<AdminLeads />} />
              <Route path="recursos-gratis" element={<AdminRecursosGratis />} />
              <Route path="suscriptores"  element={<AdminSuscriptores />} />
              <Route path="usuarios" element={<AdminUsuarios />} />
              <Route path="ventas"        element={<AdminPlaceholder titulo="Ventas" subtitulo="Registro de ventas web y WhatsApp." />} />
              <Route path="puntos" element={<AdminPuntos />} />
              <Route path="boletin"       element={<AdminPlaceholder titulo="Boletín" subtitulo="Suscriptores y envíos de correo." />} />
              <Route path="configuracion" element={<AdminPlaceholder titulo="Configuración" subtitulo="Ajustes generales del sitio." />} />
              <Route path="formaciones-gratis" element={<AdminFormacionesGratis/>} />
              <Route path="pedidos" element={<AdminPedidos />} />
              <Route path="reclamaciones" element={<AdminReclamaciones/>}/>
              <Route path="hero-carrusel" element={<AdminHeroCarrusel/>}/>
              <Route path="reportes" element={<AdminReportes/>}/>
              <Route path="cupones" element={<AdminCupones/>}/>
              <Route path="articulos" element={<AdminArticulos/>}/>
              <Route path="articulos-comentarios" element={<AdminComentariosArticulos/>}/>

            </Route>

            <Route path="*" element={<Navigate to="/" replace />} />

          </Routes>
        </AuthUserProvider>
      </AuthProvider>
    </Router>

    </CartProvider>
  );
}

export default App;